import React from 'react';

const EMPTY_TEXT = 'Not provided';

// [label, where the value comes from on the normalized user]
const PERSONAL_FIELDS = [
    ['Full Name', (user) => user.name],
    ['Email Address', (user) => user.email],
    ['Phone Number', (user) => user.phone_number],
];

const WORK_FIELDS = [
    ['Role', (user) => user.role],
    ['Designation', (user) => user.designation],
    ['Department', (user) => user.department],
    ['Location', (user) => user.location],
    ['Reporting Manager', (user) => user.manager_name],
    ['Joined Date', (user) => user.joined_date || user.created],
];

const Section = ({ title, fields, user }) => (
    <div className="content-card profile-card">
        <h3 className="card-heading">{title}</h3>
        <div className="profile-fields-grid">
            {fields.map(([label, read]) => {
                const value = read(user);
                const hasValue = value !== undefined && value !== null && String(value).trim() !== '';
                return (
                    <div className="info-field-group" key={label}>
                        <span className="info-field-label">{label}</span>
                        <span className={`info-field-value${hasValue ? '' : ' info-field-empty'}`}>
                            {hasValue ? value : EMPTY_TEXT}
                        </span>
                    </div>
                );
            })}
        </div>
    </div>
);

/** The Profile tab: personal and work information, each as a card with the details in three columns. */
const UserProfileSections = ({ user }) => (
    <div className="profile-sections">
        <Section title="Personal Information" fields={PERSONAL_FIELDS} user={user} />
        <Section title="Work Information" fields={WORK_FIELDS} user={user} />
    </div>
);

export default UserProfileSections;
